<div fxLayout="column" fxLayoutAlign="space-around stretch" fxFlex="95">
    <h3 *ngIf="message" class="syn--margin-bottom-0">
        {{ message }}
    </h3>
    <div *ngIf="showPaginator">
        <mat-form-field class="syn--pull-right" [style.fontSize.px]="12" appearance="outline">
            <mat-label>Filtrer</mat-label>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrer">
        </mat-form-field>
    </div>

    <mat-table #table [dataSource]="dataSource" matSort>

        <!-- id -->
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-company-avatar [company]="row" [showId]="true" [size]="24"></syn-company-avatar>
            </mat-cell>
        </ng-container>

        <!-- name -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nom </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
        </ng-container>

        <!-- source -->
        <ng-container matColumnDef="source">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Source </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-source [source]="row.source"></syn-source>
            </mat-cell>
        </ng-container>

        <!-- notes -->
        <ng-container matColumnDef="notes">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Notes </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.notes}} </mat-cell>
        </ng-container>

        <!-- tags -->
        <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Tags </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <mat-chip-listbox>
                    <mat-chip disableRipple disabled class="readonly-chip" *ngFor="let tag of row.tags">{{tag}}</mat-chip>
                </mat-chip-listbox>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator *ngIf="showPaginator" #paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
</div>
